import React from "react";
import { motion } from "framer-motion";
import $ from "jquery";
import SwipeScreen from "../../SwipeScreen";
import { AppBlocContext } from "../AppBlocContext";
import { AnimateHeight } from "./AnimatedHeight";
import Loader from "../../Loader";
import AnimationVariants from "./Helpers/animation-variants";

export default class HomeRoom extends React.Component {
    constructor( props ) {
        super(props);
        this.homeRoomRef = React.createRef();
        this.SwipeScreen = null;
    }

    componentDidMount() {

    }

    componentDidUpdate( _, __, ___ ) {
        if ( this.SwipeScreen !== null ) this.SwipeScreen.destroy();

        this.SwipeScreen = new SwipeScreen($(this.homeRoomRef.current));
    }

    showStorylineSelect = ( e ) => {
        e.preventDefault();
        this.props.appBloc.showStorylineSelect();
    };

    selectStoryLine = ( e, storyline ) => {
        e.preventDefault();
        this.props.appBloc.selectStoryLine(storyline);
    };

    getRoomClasses = () => {
        let classes = '';

        if ( ( this.props.state?.homeState?.showStorylineSelect ?? false ) ) {
            classes += '  home-screen--show-storyline-select';
        }

        if ( ( this.props.state?.showHouse ?? false ) ) {
            classes += '  home-screen--show-room';
        }

        return classes;
    };

    render() {
        let thumbnailUrl = $('#museums-app').attr('data-thumbnail');
        let offsetX      = $(this.homeRoomRef.current)?.find('.js-swipe-screen-bg')?.attr('data-offset-x') ?? 0;
        let state        = this.props.state;

        return <div className={`swipe-screen  [ home-screen ]  [ js-swipe-screen ]  [ ${this.getRoomClasses()} ]`}
                    ref={this.homeRoomRef}
                    id="home-room"
                    data-static-mode="cover">

            <div className="swipe-screen__background-container  [ js-swipe-screen-bg ]" data-offset-x={offsetX} data-offset-y="0">
                <div className="swipe-screen__background">
                    <div className="swipe-screen__image">
                        <img src={thumbnailUrl} alt="Benedict Nimser Haus"/>
                    </div>

                    <div className="swipe-screen__spots">
                        {/*No Spots on HomeScreen*/}
                    </div>
                </div>
            </div>

            <div className="swipe-screen__foreground  [ home-screen__foreground ]">
                <a href="#" className="[ menu-btn ]  [ home-screen__menu-btn ]  [ js-menu-open ]">
                    <span className="icon">
                        <svg viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g fill="currentColor">
                            <path d="M0 2.52002C0.197581 2.28902 0.381048 1.96352 0.550403 1.54352C0.747984 1.12352 0.846774 0.714015 0.846774 0.315015H16.7661C18.2056 0.315015 19.25 0.283516 19.8992 0.220516C20.5766 0.136516 20.9436 0.0630151 21 1.52588e-05C20.8024 0.210015 20.6048 0.525016 20.4073 0.945016C20.2379 1.34402 20.1532 1.76402 20.1532 2.20502H5.08065C3.52823 2.20502 2.34274 2.24702 1.52419 2.33102C0.705645 2.39402 0.197581 2.45702 0 2.52002Z"/>
                            <path d="M0 8.40002C0.197581 8.16902 0.381048 7.84352 0.550403 7.42352C0.747984 7.00352 0.846774 6.59402 0.846774 6.19502H16.7661C18.2056 6.19502 19.25 6.16352 19.8992 6.10052C20.5766 6.01652 20.9436 5.94302 21 5.88002C20.8024 6.09002 20.6048 6.40502 20.4073 6.82502C20.2379 7.22402 20.1532 7.64402 20.1532 8.08502H5.08065C3.52823 8.08502 2.34274 8.12702 1.52419 8.21102C0.705645 8.27402 0.197581 8.33702 0 8.40002Z"/>
                            <path d="M0 14.28C0.197581 14.049 0.381048 13.7235 0.550403 13.3035C0.747984 12.8835 0.846774 12.474 0.846774 12.075H16.7661C18.2056 12.075 19.25 12.0435 19.8992 11.9805C20.5766 11.8965 20.9436 11.823 21 11.76C20.8024 11.97 20.6048 12.285 20.4073 12.705C20.2379 13.104 20.1532 13.524 20.1532 13.965H5.08065C3.52823 13.965 2.34274 14.007 1.52419 14.091C0.705645 14.154 0.197581 14.217 0 14.28Z"/>
                        </g>
                    </svg>

                    </span>
                            <span className="label">
                        Menü
                    </span>
                </a>

                <div className="home-screen__top-content">
                    <AnimateHeight
                        variants={AnimationVariants.heightScaleDownFade}
                        isVisible={( state?.homeState?.showStart ?? true )}>
                        <div className="hero__headline">
                            <div className="hero__subtitle  [ wow fadeInUp ] [ margin__bottom--small ]" data-wow-delay="0s">
                                Willkommen im
                            </div>
                            <h1 className="hero__title  [ wow fadeInUp ]  margin__bottom--small" data-wow-delay="0.1s">
                                Benedict <br/>
                                Nimser <br/>
                                Haus
                            </h1>
                            <h2 className="hero__subtitle  |  wow  fadeInUp" data-wow-delay="0.2s">Geschichten aus Wilhelmsdorf</h2>
                        </div>
                    </AnimateHeight>

                    <AnimateHeight
                        variants={AnimationVariants.heightScaleDownFade}
                        isVisible={( state?.homeState?.showStorylineSelect ?? false )}
                        className="storyline-select__content">
                        <div className="hero__headline  storyline-select__headline">
                            <div className="hero__subtitle  [ wow fadeInUp ] [ margin__bottom--small ]">
                                Wähle eine
                            </div>
                            <h2 className="hero__title  [ wow fadeInUp ]  [ margin__bottom--medium ]" data-wow-delay="0.1s">
                                Erzählweise
                            </h2>

                            <div className="h4  inner">
                                Wir haben die Geschichte von Wilhelmsdorf und Bendict Nimser in zwei verschiedenen Erzählweisen aufbereitet:
                            </div>
                        </div>
                    </AnimateHeight>
                </div>

                <div className="home-screen__bottom-actions">
                    {( state?.homeState?.showStorylineSelect ?? false ) &&
                    <motion.div
                        className="storyline-select__bottom-actions"
                        variants={AnimationVariants.scaleUpFade}
                        initial={"hidden"}
                        animate={( ( state?.homeState?.showStorylineSelect ?? false ) ) ? 'visible' : 'hidden'}>
                        <div className="storyline-select__buttons">
                            {state.storylines.map(( storyline, i ) =>
                                <a href="#" className="button  button--large"
                                   onClick={( ev ) => this.selectStoryLine(ev, storyline)}
                                   key={i}
                                >
                                    {storyline.name}
                                </a>
                            )}
                        </div>
                    </motion.div>
                    }

                    <AnimateHeight
                        variants={AnimationVariants.heightScaleUpFade}
                        isVisible={( state?.homeState?.showStart ?? true )}
                        duration={0.35}
                        className={`home-screen__enter-container`}
                    >
                        <div className="instruction-info  [ wow fadeInUp ]  [ margin__bottom--small ]">
                            <div className="instruction-info__icon">
                                <svg viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="currentColor">
                                        <path
                                            d="M18.0612 7.57765C17.5694 7.51059 17.1223 7.71177 16.8317 8.02471C16.6753 7.39883 16.1165 6.95176 15.4682 6.95176C15.0435 6.95176 14.6635 7.15294 14.3953 7.46588C14.2165 6.90706 13.68 6.48235 13.0541 6.48235C12.6741 6.48235 12.3165 6.63883 12.0482 6.90706V1.58706C12.0482 0.871762 11.5341 0.223527 10.8188 0.134116C9.96941 0.0223511 9.23176 0.692941 9.23176 1.52V11.02C9.23176 11.1988 8.98588 11.2882 8.87411 11.1318L7.24235 8.65059C6.86235 8.06941 6.01294 7.9353 5.3647 8.36C4.71647 8.78471 4.49294 9.61175 4.8953 10.1929C4.8953 10.1929 9.47764 17.1223 9.49999 17.1447C10.3271 18.307 11.6682 19 13.1435 19H14.7753C17.2341 19 19.2459 17.0329 19.2682 14.5965C19.2682 14.5741 19.2682 14.5294 19.2682 14.5071V9.05294C19.2682 8.31529 18.7541 7.66706 18.0612 7.57765Z"/>
                                        <path
                                            d="M7.89058 1.76589C7.89058 1.45295 7.6447 1.20706 7.33175 1.20706H2.57059V0.447058C2.57059 0.268235 2.45882 0.111767 2.30235 0.0447086C2.23529 0.0223556 2.16823 0 2.12353 0C2.01176 0 1.92235 0.0447058 1.83294 0.111765L0.156473 1.54236C0.0447086 1.63177 0 1.76588 0 1.9C0 2.03412 0.067056 2.16823 0.178821 2.23529L1.85529 3.44235C1.98941 3.53177 2.16824 3.55411 2.32471 3.48705C2.48118 3.41999 2.57059 3.24118 2.57059 3.06235V2.34706H7.33175C7.6447 2.34706 7.89058 2.07883 7.89058 1.76589Z"/>
                                        <path
                                            d="M21.0788 1.54236L19.4023 0.111765C19.3129 0.0447058 19.2235 0 19.1117 0C19.0447 0 18.9776 0.0223556 18.9329 0.0447086C18.7765 0.111767 18.6647 0.268235 18.6647 0.447058V1.20706H13.9035C13.5906 1.20706 13.3447 1.45295 13.3447 1.76589C13.3447 2.07883 13.5906 2.32471 13.9035 2.32471H18.6647V3.06235C18.6647 3.24118 18.7541 3.39764 18.9106 3.48705C19.067 3.55411 19.2459 3.55412 19.38 3.44235L21.0565 2.23529C21.1682 2.14588 21.2353 2.03412 21.2353 1.9C21.2353 1.76588 21.1906 1.63177 21.0788 1.54236Z"/>
                                    </g>
                                </svg>

                            </div>

                            <div className="instruction-info__text">
                                Nach links oder rechts <br/>
                                wischen, um sich umzusehen.
                            </div>
                        </div>

                        <a href="#" className={`home-screen__enter-btn  [ button  button--large ]  [ wow fadeInUp ]`}
                           data-wow-delay="0.2s"
                           onClick={this.showStorylineSelect}>
                            {( state?.storylines !== null ) &&
                            <span>Eintreten</span>}

                            {( state?.storylines === null ) &&
                            <Loader></Loader>}
                        </a>
                    </AnimateHeight>
                </div>
            </div>

        </div>;
    }

}
